export default __webpack_public_path__ + "static/media/fixed.514612f7.svg";